import { Badge, type BadgeProps } from "../ui/badge.js";

// HR's review of a professional reference. Shown to HR (profile) and to the
// employee (wizard step 6), where flagged ones explain what to do next.
const REFERENCE_STATUS: Record<string, { label: string; tone: BadgeProps["tone"] }> = {
  PENDING:             { label: "Awaiting HR check", tone: "neutral" },
  VERIFIED:            { label: "Verified", tone: "success" },
  UNREACHABLE:         { label: "Could not be contacted", tone: "warning" },
  ALTERNATE_REQUESTED: { label: "Alternate requested", tone: "error" },
};

export function ReferenceStatusBadge({ status }: { status: string | null | undefined }) {
  const s = REFERENCE_STATUS[status ?? "PENDING"] ?? REFERENCE_STATUS["PENDING"]!;
  return <Badge tone={s.tone}>{s.label}</Badge>;
}
